export const NETWORK_ERROR = "Something went wrong please verify your internet connection and try again.";

// export const baseUrl = "http://192.168.68.54:8080";
// export const baseWebUrl = "http://192.168.68.54:3000";

// export const baseUrl = "http://localhost:8080";
// export const baseWebUrl = "http://localhost:3000";

export const baseUrl = "https://api.virtualtipz.com";
export const baseWebUrl = "https://www.virtualtipz.com";
//export const baseWebStripePaymentSuccessUrl = "https://www.virtualtipz.com/checkout/success";
export const baseWebStripePaymentSuccessUrl = baseWebUrl + "/checkout/success";

export const vtDancerMessageURI = "/topic/venue/";

export const baseUri = "/api";

const buildHeader = (accessToken) => {
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);
    myHeaders.append("Content-Type", "application/json");
    return myHeaders;
};

export const fetchGet = async (
    uri,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    try {
        const accessToken = await getAccessToken();
            // authorizationParams: {
            //     audience: 'https://virtualtipzaudience',
            //     scope: "openid profile email offline_access"
            // }

        applyConfigAndFetch("GET", accessToken, uri, successMethod, errorMethod);
    } catch (e) {
        debugger;
        console.log(e.message);
    }
};

export const fetchPost = async (
    uri,
    successMethod,
    errorMethod,
    myBody = {},
    getAccessToken
) => {
    const domain = "dev-16yp2zuajbsdubke.us.auth0.com";

    try {
        const accessToken = await getAccessToken();

        // const userDetailsByIdUrl = `https://${domain}/api/v2/users/${user.sub}`;
        //
        // const metadataResponse = await fetch(userDetailsByIdUrl, {
        //     headers: {
        //         Authorization: `Bearer ${accessToken}`,
        //     },
        // });
        //
        // const { user_metadata } = await metadataResponse.json();
        //
        // setUserMetadata(user_metadata);

        applyConfigAndFetch("POST", accessToken, uri, successMethod, errorMethod, myBody);
    } catch (e) {
        console.log(e.message);
    }

};

export const fetchPatch = async (
    uri,
    successMethod,
    errorMethod,
    myBody = {},
    getAccessToken
) => {
    try {
        const accessToken = await getAccessToken();

        applyConfigAndFetch("PATCH", accessToken, uri, successMethod, errorMethod, myBody);
    } catch (e) {
        console.log(e.message);
    }
};

export const fetchPut = async (
    uri,
    successMethod,
    errorMethod,
    myBody = {},
    getAccessToken
) => {
    try {
        const accessToken = await getAccessToken();

        applyConfigAndFetch("PUT", accessToken, uri, successMethod, errorMethod, myBody);
    } catch (e) {
        console.log(e.message);
    }
};

export const fetchDelete = async (
    uri,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    try {
        const accessToken = await getAccessToken();

        applyConfigAndFetch("DELETE", accessToken, uri, successMethod, errorMethod);
    } catch (e) {
        console.log(e.message);
    }
};


const applyConfigAndFetch = (method, accessToken, uri, successMethod, errorMethod, myBody) => {
    const config = myBody ? {
        method: method,
        headers: buildHeader(accessToken),
        //mode: 'cors',
        cache: "default",
        body: JSON.stringify(myBody)
    } : {
        method: method,
        headers: buildHeader(accessToken),
        //mode: 'cors',
        cache: "default"
    };

    fetch(baseUrl + uri, config)
        .then(function (response) {
            // console.log(
            //     "******************************" + method + "******************************"
            // );
            //console.log(response);
            return checkResponseStatus(uri, response, successMethod, errorMethod);
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            // console.log("ERROR IS");
            // console.log(error);
            errorMethod(true);
        });
};

const checkResponseStatus = (uri, response, successMethod, errorMethod) => {
    if (
        response.ok ||
        response.status === 400
    ) {
        return response.json();
    } else if (response.status === 401) {
        errorMethod(true);
        return false;
    } else if (response.status === 404) {
        errorMethod(true);
        return false;
    } else if (response.status === 405) {
        //alert("Method not Allowed");
        //throw new Error("Resource Not Found");
        errorMethod(true);
        return false;
    } else {
        //alert(NETWORK_ERROR);
        //throw new Error(NETWORK_ERROR);
        errorMethod(true);
        return false;
    }
}